/*------------------------------------*\
    Swiper
\*------------------------------------*/
module.exports = function(){



    // home

    if (currentTemplate == 'home') {

        /**
         * Swiper
         */

        var autoplayLength = 7000;
        var autoplayLengthCss = autoplayLength + 'ms';

        window.homeSwiper = new Swiper ('.swiper-container', {
            direction: 'horizontal',
            effect: 'fade',
            speed: 1200,
            loop: false, // 'true' will ruin the pagination because of an indexing issue
            // autoplayStopOnLast: true,
            // autoplayDisableOnInteraction: true,
            lazyLoading: true,
            autoplay: autoplayLength,
            pagination: '.custom-swiper-pagination',
            paginationType: 'bullets',
            paginationClickable: true,
            paginationBulletRender: function(index, className) {
                var $slide = $('.' + this.wrapperClass).find('.swiper-slide')[index];
                return '<li class="slider__pager-link ' + className + '" data-index="' + index + '">' + $($slide).attr('data-label') + '<div class="slider__progress-container"><span class="slider__progress" style="-webkit-animation-duration:' + autoplayLengthCss + '; -moz-animation-duration:' + autoplayLengthCss + '; animation-duration:' + autoplayLengthCss + '"></span></div></li>';
            }
        });

    }






    // team

    if (currentTemplate == 'team') {

        /**
         * Swiper
         */

        window.teamSwiper = new Swiper ('.js-team-swiper', {
            slidesPerView: 4,
            centeredSlides: true,
            spaceBetween: 30,
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            loop: true,
            lazyLoading: true,
            autoplay: false,
            onInit: function(swiper) {

                var $slideWidth = $('.swiper-slide[data-swiper-slide-index="' + swiper.activeIndex + '"]').width();
                var $slideHeight = $('.swiper-slide[data-swiper-slide-index="' + swiper.activeIndex + '"]').height();

                if ( (typeof $slideWidth != 'undefined') && typeof ($slideHeight != 'undefined') ) {

                    //var heightCss = 'height: ' + ($slideHeight) + 'px';

                    $('.swiper-container').prepend('<div class="slider__cover--carousel  slider-cover-team" style="width: ' + ($slideWidth / 2) + 'px;"></div>');
                    $('.swiper-container').append('<div class="slider__cover--carousel  slider-cover-team" style="width: ' + ($slideWidth / 2) + 'px;"></div>');

                }

            },
            breakpoints: {
                700: {
                    slidesPerView: 'auto',
                    spaceBetween: 10,

                    /*
                    onInit: function(swiper) {
                        var $slideWidth = $('.swiper-slide[data-swiper-slide-index="' + swiper.activeIndex + '"]').width();
                        var $slideHeight = $('.swiper-slide[data-swiper-slide-index="' + swiper.activeIndex + '"]').height();
                        if ( (typeof $slideWidth != 'undefined') && typeof ($slideHeight != 'undefined') ) {
                            $('.swiper-container').prepend('<div class="slide__cover--carousel  slide-cover-team" style="width: ' + ($slideWidth) + 'px; height: ' + ($slideHeight) + 'px;"></div>');
                            $('.swiper-container').append('<div class="slide__cover--carousel  slide-cover-team" style="width: ' + ($slideWidth) + 'px; height: ' + ($slideHeight) + 'px;"></div>');
                        }

                    },
                    */



                }
            }
        });


    }







}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/blocks/swiper.js